module.exports = __webpack_public_path__ + "static/media/4.1e709fd3.png";